import { Browser } from './user-agent-state.model';

export namespace UserAgentActions {
    export class Set {
        static readonly type = '[UserAgent] Set';
        constructor(public payload: { browser: Browser }) {}
    }
}